// src/components/demo/DemoPricingSection.jsx
import React, { useState } from "react";
// import DemoPricingContactForm from "./DemoPricingContactForm";

const plans = [
  {
    id: "small",
    badge: "Moins de 1 000 habitants",
    label: "Communes < 1 000 habitants",
    subscription: 240,
    short:
      "Pour les petites communes qui souhaitent un site moderne, simple et efficace.",
  },
  {
    id: "medium",
    badge: "Entre 1 000 et 5 000 habitants",
    label: "Communes de 1 000 à 5 000 habitants",
    subscription: 340,
    short:
      "Adapté aux communes avec davantage de services, de contenus et d’actualités à publier.",
  },
  {
    id: "large",
    badge: "Plus de 5 000 habitants",
    label: "Communes > 5 000 habitants",
    subscription: 440,
    short:
      "Pour les communes plus importantes : même application, même niveau de service.",
  },
];

export default function DemoPricingSection() {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleAskQuote = (plan) => {
    setSelectedPlan(plan);
    // scroll vers le formulaire (#contact) si besoin
    const el = document.getElementById("contact");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section
      id="tarifs"
      className="mx-auto max-w-[1200px] px-4 sm:px-6 mt-16"
    >
      <Header
        title="Tarifs MonAppliMairie"
        subtitle="Une seule application, des tarifs adaptés à la taille de votre commune"
      />

      <p className="mt-4 text-center text-sm text-slate-600 dark:text-slate-300 max-w-2xl mx-auto">
        Quelle que soit la taille de votre commune, vous profitez de{" "}
        <strong>la même application MonAppliMairie</strong> et du même niveau
        d’accompagnement. Seul le montant de l’abonnement annuel varie selon le
        nombre d’habitants.
      </p>

      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {plans.map((plan) => (
          <article
            key={plan.id}
            className="relative rounded-2xl border border-slate-200/70 dark:border-slate-700/80 shadow-sm bg-white/85 dark:bg-slate-900/85 p-6 flex flex-col transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl"
          >
            <div className="mt-1">
              <div className="text-xs font-semibold uppercase tracking-wide text-primary/80">
                {plan.badge}
              </div>
              <h3 className="mt-2 text-lg font-semibold">{plan.label}</h3>
              <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">
                {plan.short}
              </p>
            </div>

            {/* Bloc prix : abonnement + pack hébergement distinct */}
            <div className="mt-4 space-y-1">
              <div className="text-2xl font-bold">
                {plan.subscription} € / an
              </div>
              <div className="text-xs text-slate-500 dark:text-slate-400">
                Abonnement annuel MonAppliMairie
              </div>
              <div className="text-xs text-slate-500 dark:text-slate-400">
                + 60 € / an : pack hébergement (nom de domaine, site, serveur &
                base de données)
              </div>
            </div>

            {/* Rappel de ce que comprend l’offre (pas les fonctionnalités détaillées) */}
            <ul className="mt-5 space-y-2 text-sm text-slate-600 dark:text-slate-300 flex-1">
              <li>• Mise en place complète du site pour votre commune</li>
              <li>• Accompagnement au paramétrage (logo, couleurs, services…)</li>
              <li>• Aide à la mise en ligne des premiers contenus</li>
              <li>• Démonstrations et visio de formation pour le personnel</li>
              <li>• Assistance et suivi dans la durée</li>
            </ul>

            <div className="mt-6">
              <button
                type="button"
                onClick={() => handleAskQuote(plan)}
                className="inline-flex w-full items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold uppercase tracking-wide border border-border/40 focus:outline-none focus:ring-2 focus:ring-ring transition hover:opacity-95"
                style={{
                  backgroundColor: "rgb(var(--color-btn-primary))",
                  color: "rgb(var(--color-on-btn-primary))",
                }}
              >
                Demander un devis
              </button>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-5 text-center text-xs text-slate-500 dark:text-slate-400 space-y-1">
        <p>
          Les tarifs indiqués sont <strong>annuels</strong> (pas de
          facturation mensuelle) et comprennent l’accès complet à
          l’application, les mises à jour et l’accompagnement.
        </p>
        <p>
          Un système de <strong>parrainage</strong> permet de bénéficier de{" "}
          <strong>10% de réduction</strong> sur le montant de l’abonnement
          annuel MonAppliMairie.
        </p>
      </div>

      {/* Formulaire de contact pour devis, pré-rempli selon la formule choisie */}
      {/* <DemoPricingContactForm selectedPlan={selectedPlan} /> */}
    </section>
  );
}

function Header({ title, subtitle }) {
  return (
    <div className="flex items-center justify-center gap-6">
      <span className="hidden sm:block h-px w-24 bg-border" />
      <div className="text-center">
        <h2 className="text-3xl md:text-[34px] font-semibold tracking-wide">
          {title}
        </h2>
        <p className="text-sm text-muted mt-1">{subtitle}</p>
      </div>
      <span className="hidden sm:block h-px w-24 bg-border" />
    </div>
  );
}
